import './App.css';
import logo from './images/harsgen_logo.jpg'
import ContactForm from "./ContactForm";
function App() {
  return (
    <div className="App">
     
<header>
    
<div class="logo-container">
    <div class="logo-circle">
            <img src={logo} alt="Company Logo" class="logo" />


    </div>
    <h2>HarsGenTech</h2>
</div>

<nav>
<a href="#">Home</a>
<a href="#about">About</a>
<a href="#services">Services</a>
<a href="#contact">Contact</a>
</nav>

</header>

<section class="hero">

<div>

<h1>Enterprise Class Design,</h1>
<h1> Architecture & Engineering</h1>
<h1>For your Web and Mobile Application</h1>

<p>Building Digital Products for Modern Businesses</p>

<a href="#contact" class="btn">Get Started</a>

</div>

</section>

<section id="about">

<div class="about">

<img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=700"/>

<div>

<h2>About Us</h2>

<br />
<h3>Proven expertise in delivering Cutting edge solutions for web and mobile applications for over 4000+ web projects and 300+ Mobile apps</h3>
<p>
HarsGenTech is an IT company specializing in software
development, cloud computing, web applications, mobile apps,
AI solutions, and digital transformation.
</p>
<br/>
<p>We have around since long time, 2003 developing web and mobile applications, delivering custom software solutions 
  as trusted and preferred offshore partners for Industry leaders, Fortune 500 companies, SMEs who promote our solutions 
  under their brand name. With over 21+ yrs of IT experience offering custom software solutions to companies from different 
  geographies and industries, we have gained significant expertise to offer enterprise grade solutions of world class quality. 
  With 4000+ web projects and 300+ mobile projects in our portfolio, some of which have been rebranded as hundreds of applications, 
  and as makers of softwares with millions user base, appstore top ranking and award winning apps, We have proved ourselves to be a 
  leading, long-standing and trustworthy solution provider in India.</p>

<br />

<p>
We help startups and enterprises create scalable, secure,
and innovative software products.
</p>

</div>

</div>

</section>

<section id="services" class="services">

<h2 align="center">Our Services</h2>

<div class="cards">

<div class="card">
<h3>Web Development</h3>
<p>Responsive business websites and enterprise web applications.</p>
</div>

<div class="card">
<h3>Mobile Apps</h3>
<p>Android, iOS and Cross-platform application development.</p>
</div>

<div class="card">
<h3>Cloud Services</h3>
<p>AWS, Azure, DevOps, Docker, Kubernetes and Serverless Solutions.</p>
</div>

<div class="card">
<h3>Ecommerce Development</h3>
<p>Creating dynamic simple intuitive and secure eCommerce sites, marketplaces with custom or third party solution - WP, Prestashop, Magento, etc</p>
</div>

<div class="card">
<h3>CMS Development</h3>
<p>Providing CMS development services from simple websites to rich web portals with WP, Drupal, Joomla, Cmsms, etc</p>
</div>

<div class="card">
<h3>MAC Development</h3>
<p>From Design to Development of MAC Solutions, Systems, migrations to Mac & cross platform integrations</p>
</div>

<div class="card">
<h3>UI/UX Design</h3>
<p>Creating simple and beautiful designs, intuitive content access offering a great user experience</p>
</div>

<div class="card">
<h3>API Development</h3>
<p>Creating scalable and secure APIs/Webservices with XML/JSON, Secure authentication with OAUTH, Encrypted data, Well structured Endpoints with versioning</p>
</div>

</div>

</section>

<section id="services" class="services">

<h2 align="center">Our Team</h2>

<div class="card" style={{backgroundColor:"#337ab7"}}>
<p style={{color:"white"}}>HarsGenTech is a team of 100+ staff members working full time to deliver quality products and services. 
  Our team is a diverse group of passionate professionals from seasoned experts with a decade experience to 
  recently graduated young brains bringing together expertise, commitment, innovation, and energy. Our team 
  stays up-to-date with technology through extensive training programs to deliver cutting
   edge solutions to satisfy the business requirements.</p>
</div>
</section>



<section id="contact" class="contact">

<h2>Contact Us</h2>

<ContactForm />

<br />

<p>Email : info@harsgentech.com</p>

<p>Phone : +91 8778456942</p>

<p>Address : No 88/2, Villianur Road, Reddiarpalayam, Marie Oulgaret, Puducherry, 605010</p>

</section>

<footer>

<p>© 2026 HarsGenTech. All Rights Reserved.</p>

</footer>
    </div>
  );
}

export default App;
